import { Helpers } from '../../helpers';
import { IWellProfile } from '../../interfaces/iwell-profile';
import { Well } from '../well';

export class WellProfileBase {
  WellProfileId: number;
  WellProfileName: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  Wells_WellProfile?: Array<Well> | null;

  constructor(item?: IWellProfile) {
    if (item) {
      this.WellProfileId = item.WellProfileId;
      this.WellProfileName = item.WellProfileName;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.Wells_WellProfile = Helpers.createClassArray(Well, item.Wells_WellProfile);

    }
  }
}